import * as api from '@/api';
import {mapMutations, mapGetters, mapActions} from 'vuex'

export default {
  async beforeMount() {
    api.setCompanyId(this.$route.params.cid);
    localStorage.setItem('CID', this.$route.params.cid)
    this.setCompanyId(this.$route.params.cid);
    this.readCompanySettings();
    await this.fetchSalons();

    if (this.$route.params.sid) this.selectSalon(this.$route.params.sid)
  },
  methods: {
    ...mapMutations('client', ['setCompanyId', 'readCompanySettings']),
    ...mapActions("client", ["selectSalon"]),
    ...mapActions('salons', ['fetchSalons']),
  },
  computed: {
    ...mapGetters('client', ['getCompanyId', 'getSalonId']),
  }
}
